import { type UserSubscriptionType } from '../subscriptions';

export enum Vendor {
  Vonage = 'Vonage',
}

export type LbRoomAdmin = {
  id: number;
  title: string;
  firstName: string;
  lastName: string;
  displayName: string;
  userProfilePictureUrl: string;
  subscriptionType: UserSubscriptionType;
};

type RoomCommon = {
  name: string;
  isPersonal: boolean;
  /** The name displayed throughout the app */
  displayName: string | null;
  roomAdmin: LbRoomAdmin;
  callVendor: Vendor;
  slug: string;
  widgets?: RoomWidget[];
  /** Comma separated ids of widgets in proper order */
  widgetsOrder?: string;
  usePasscode: boolean;
  passcode?: string;
  /** Original value of usePasscode if it was overridden by og-api because of a permissions check */
  usePasscodeStoredValue?: boolean;
  tosURL?: string;
  created?: Date;
  lastUpdated?: Date;
  cameraOff?: boolean;
  doxyBotCheckIn?: boolean;
  institutionId?: number;
  displayOnLanding?: boolean;
  creatorId?: unknown;
  checkInPhotoCapture?: boolean | null;
  /** Options to redirect the patient to the corresponding clinic room.*/
  shouldRedirect?: boolean;
  redirectUrl?: string;
};

/**
 * Type of room value we receive from the API
 */
export type LbRoom = RoomCommon & { id: number };

/**
 * Type of room value we use throughout the app.
 *
 * There are 2 types of room id used throughout the app -
 * number received from the API and string received via Realtime.
 * Number id is converted to string and used to avoid risks of typing errors.
 */
export type Room = RoomCommon & { id: string };

export type RoomWidget = {
  id: number;
  type: string;
  text: string;
  imageUrl: string;
  videoSource: 'youtube' | 'vimeo';
  videoRemoteId: string;
};

export type PostOnCheckInDTO = {
  name: string;
  ts: number;
  url: string;
};

export type PostNotifyMembersAboutPatientDTO = {
  name: string;
  anonymousId: string;
  platformData: PlatformData;
};

export type InviteViaSmsDTO = {
  phone: string;
  language: string;
  message: string;
  edited: boolean;
};

export type InviteByEmailDTO = {
  email: string;
  language: string;
  message: string;
  edited: boolean;
};

export type NonCustomInviteByEmailDTO = {
  email: string;
  language?: string;
  calendarICS?: string;
  date?: Date;
  time?: Date;
};

export type NonCustomInviteBySmsDTO = {
  phone: string;
  language: string;
  token?: string;
  date?: Date;
  time?: Date;
};

export type PlatformData = {
  os: string;
  os_version: string;
  browser: string;
  browser_version: string;
  platform: string;
  device_model: string;
};
